module.exports = __webpack_public_path__ + "static/media/dataWindow.3314581a.svg";